<ag-grid-angular
	class="ag-theme-balham copo-datacenter-ag-grid"
	[gridOptions]="gridOptions"
	[modules]="agGridModules"
	(gridReady)="onGridReady($event)"
	(viewportChanged)="onViewportChanged($event)">
</ag-grid-angular>